"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleScalarType = void 0;
const scalarTypes_1 = require("./scalarTypes");
const handleScalarType = function ({ type }) {
    const graphqlTypeName = scalarTypes_1.scalarTypes[type];
    const graphqlTypeDefinitions = [];
    return {
        typeName: graphqlTypeName,
        typeDefinitions: graphqlTypeDefinitions
    };
};
exports.handleScalarType = handleScalarType;
